import styled from '@emotion/styled';
import { EventHeaderCaptionWrapper } from 'src/domains/sportsbook/webview/components/sportEventsListNew/EventGroupHeaderUnified.style';
import { withConfig } from 'src/withConfig';

export const CorrectScoreRoot = styled('div', { label: 'CorrectScoreRoot' })`
    width: 100%;
`;

export const HeaderCell = withConfig(theme => styled('span', { label: 'HeaderCell' })`
    color: ${theme.star.unified.eventHeaderCaption.txtColorSecondary};
    font-size: ${theme.star.fontSize.small};
    font-weight: ${theme.star.fontWeight.regular};
    text-align: center;
    width: 100%;
`);

export const SelectionsGroupWrapper = styled('div', { label: 'SelectionsGroupWrapper' })`
    display: flex;

    & [class$='SelectionGroupListVersion'] {
        gap: 0;

        &:first-of-type > div {
            padding-left: 8px;
        }
        &:last-of-type > div {
            padding-right: 8px;
        }
    }
`;

export const SelectionHeader = styled(EventHeaderCaptionWrapper, { label: 'SelectionHeader' })`
    display: flex;
    justify-content: space-around;
    gap: 4px;
    
    & [class$='EventHeaderCaption'] {
        width: 100%;
    }
`;

export const SelectionCell = withConfig(theme => styled('div', { label: 'SelectionCell' })`
    min-width: 0;
    width: 100%;
    border-bottom: 1px solid ${theme.star.unified.selection.borderColor};
    min-height: 61px;
    display: flex;
    align-items: center;
    justify-content: center;
    align-self: stretch;
    padding: 8px 4px;

    .selection {
        display: flex;
        justify-content: center;
        flex: 1;
        align-self: stretch;
    }
`);
